import { Box, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import s from './page.module.scss';

type Props = {
  className?: string;
  slotLeft?: ReactNode;
  slotCenter?: ReactNode;
  slotRight?: ReactNode;
  children?: ReactNode;
};

function MainHeading({ title }: { title: ReactNode }): JSX.Element {
  return (
    <Text.Heading variant="heading-2" as="h1" data-testid="main-heading">
      {title}
    </Text.Heading>
  );
}
type SubTitleProps = {
  subtitle: ReactNode;
};
function SubTitle({ subtitle }: SubTitleProps) {
  return (
    <Text.Paragraph variant="4" subdued>
      {subtitle}
    </Text.Paragraph>
  );
}

export const HeadBackLink = ({
  backProps,
  backText,
}: {
  backText: string;
  backProps: LinkProps;
}): JSX.Element => {
  return (
    <Link className={s.link} {...(backProps as LinkProps)}>
      <Icon name="angle-left" className={s.linkArrow} />
      {backText}
    </Link>
  );
};

type HeadTitleProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
};
export const HeadTitle = ({
  title,
  subtitle,
  className,
}: HeadTitleProps): JSX.Element => {
  return subtitle ? (
    <FlexBox className={className} flexDirection="column">
      <FlexBox alignItems="center">
        <MainHeading title={title} />
      </FlexBox>
      <Box>
        <SubTitle subtitle={subtitle} />
      </Box>
    </FlexBox>
  ) : (
    <FlexBox className={className} alignItems="center">
      <MainHeading title={title} />
    </FlexBox>
  );
};

export const Head = ({
  className,
  slotCenter,
  slotLeft,
  slotRight,
  children,
}: Props): JSX.Element => {
  return (
    <div className={className} id="pageHead">
      <div className={cx('pageHead', s.head)}>
        {!!slotLeft && <Box className={s.slotLeft}>{slotLeft}</Box>}
        {!!slotCenter && <Box className={s.slotCenter}>{slotCenter}</Box>}
        {!!slotRight && <Box className={s.slotRight}>{slotRight}</Box>}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};
